import { Chip } from '@/components/DesignSystem';
import { Color } from '@/themes/MUITheme/palette';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface BookingStatusBadgeProps {
  bookingData: {
    expirationDate?: Date | null,
    isClosed: boolean,
  },
}

export const BookingStatusBadge = ({
  bookingData,
}: BookingStatusBadgeProps) => {
  const { t } = useTranslation();
  
  let color: Color | undefined = undefined;
  let text: string;
  let backgroundColor: string | undefined = undefined;
  
  if (bookingData.isClosed) {
    text = t($ => $.common.status.closed);
    backgroundColor = '#757575';
  } else if (bookingData.expirationDate && bookingData.expirationDate < new Date()) {
    text = t($ => $.common.status.expired);
    backgroundColor = '#3C3C3C';
  } else {
    color = 'success';
    text = t($ => $.common.status.active);
  }
  
  return (
    <Chip
      color={color}
      label={text}
      size="xsmall"
      sx={{ backgroundColor, color: 'white' }}
      testID="booking-status-badge"
    />
  );
};
